/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ForgetPasswordRequest {
    getFixupPrototypeFunction() { return ForgetPasswordRequest.fixupPrototype; }

    static newInstance(model: Partial<ForgetPasswordRequest>): ForgetPasswordRequest {
        let obj = Object.assign(new ForgetPasswordRequest(), model);
        ForgetPasswordRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ForgetPasswordRequest>): ForgetPasswordRequest {
        if (!model) return null;
        return ForgetPasswordRequest.newInstance(<ForgetPasswordRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ForgetPasswordRequest) {
        if (!obj) return;

        models.ForgetPasswordRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ForgetPasswordRequest): boolean {
        Object.setPrototypeOf(obj, ForgetPasswordRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * User email id.
     */
    email_id: string;

}
